module.exports = __webpack_public_path__ + "static/media/ppt.e8f28ab5.svg";